const i18n = require("../../config/i18n");

const linkResolver = (doc) => {
  const prefix = `/${i18n[doc.lang].path}/`;

  if (doc.uid === '' || doc.type === 'homepage') {
    return `${prefix}`;
  }

  return `${prefix}${doc.uid}/`;
};

module.exports = linkResolver;